import React, { useMemo } from "react";
import { useHistory } from "react-router";

import { Button, OnlineLink, TableTooltip } from "components";

import { ReactComponent as PencilEditIcon } from "static/images/pencil_edit.svg";

const WARRNING_MESSAGE =
	"WARNING: The edit function should only be used to edit the Residual split profile when an error was made during set up. Do not use function to create a new Residual split profile.";

type SplitProfileTableActionsProps = {
	row: { [key: string]: any };
	isEditable: boolean;
};

const SplitProfileTableActions = ({
	row,
	isEditable,
}: SplitProfileTableActionsProps) => {
	const history = useHistory();
	const splitProfile = row?.original;

	const editPath = useMemo(
		() => `${history.location.pathname}/${splitProfile.id}`,
		[history.location.pathname, splitProfile.id],
	);

	return (
		<div className="d-flex align-items-center">
			<TableTooltip
				text={WARRNING_MESSAGE}
				placement="top"
				className="text-warning"
			>
				<div>
					<Button
						btnIcon
						icon={<PencilEditIcon />}
						onClick={e => e.stopPropagation()}
						as={OnlineLink}
						to={editPath}
						variant="secondary"
						size="sm"
						className={isEditable ? "" : "disabled"}
						disabled={!isEditable}
					/>
				</div>
			</TableTooltip>
		</div>
	);
};

export default SplitProfileTableActions;
